import React from 'react'
import './RecentBallResults.scss'

function getNumberSuffix(n) {
    n = Number(n)

    if (n > 3 && n < 21) {
        return 'th'
    }

    // Check last digit
    n = String(n)
    n = Number(n[n.length-1])

    if (n === 1) {
        return 'st'
    }
    if (n === 2) {
        return 'nd'
    }
    if (n === 3) {
        return 'rd'
    }

    return 'th'
}

export default function RecentBallResults({ scoregrid }) {
    const { overs } = scoregrid || {};

    const { inns1, inns2, inns3, inns4 } = overs || {};

    let recentOvers = [];

    if (inns1){
        inns1.forEach(over => {
            let balls = []

            for (let i = 1; i <= 12; i++) {
                if (over['b' + i]) {
                    balls.unshift(over['b' + i]);
                }
            }

            recentOvers.unshift({
                over: over.ov,
                balls
            })
        })
    }

    if (inns2){
        inns2.forEach(over => {
            let balls = []

            for (let i = 1; i <= 12; i++) {
                if (over['b' + i]) {
                    balls.unshift(over['b' + i]);
                }
            }

            recentOvers.unshift({
                over: over.ov,
                balls
            })
        })
    }

    if (inns3){
        inns3.forEach(over => {
            let balls = []

            for (let i = 1; i <= 12; i++) {
                if (over['b' + i]) {
                    balls.unshift(over['b' + i]);
                }
            }

            recentOvers.unshift({
                over: over.ov,
                balls
            })
        })
    }

    if (inns4){
        inns4.forEach(over => {
            let balls = []

            for (let i = 1; i <= 12; i++) {
                if (over['b' + i]) {
                    balls.unshift(over['b' + i]);
                }
            }

            recentOvers.unshift({
                over: over.ov,
                balls
            })
        })
    }

    return (
        <div className="recent-ball-results">
                <div className="recent">
                {recentOvers.map(({ over, balls }, index) => {
                    if (! balls.length) return null;
                    return (
                        <div className="over" key={index}>
                            <span className="label">{over + getNumberSuffix(over)}</span>
                            <div className="balls">
                                {balls.map((b, i) => {
                                    let backgroundColor = '#EEE';
                                    let color = '#000';

                                    switch (b) {
                                        case '2':
                                        case '3':
                                            backgroundColor = '#2188CD';
                                            color = '#FFF';
                                            break;
                                        case '4':
                                        case '5':
                                            backgroundColor = '#4BC408';
                                            color = '#FFF';
                                            break;
                                        case '6':
                                            backgroundColor = '#F96D33';
                                            color = '#FFF';
                                            break;
                                        case 'w':
                                        case 'W':
                                        case 'Ct':
                                        case 'Bld':
                                        case 'Lbw':
                                        case 'RO':
                                        case 'Stm':
                                        case 'RO1':
                                            backgroundColor = '#000';
                                            color = '#FFF';
                                            break;
                                        default:
                                            break;
                                    }

                                    if (b === '88'){
                                        b = '...'
                                    }

                                    return (
                                        <div 
                                            className="result" 
                                            key={i} 
                                            style={{ 
                                                backgroundColor, 
                                                color,
                                                borderColor: color,
                                                borderWidth: '1px',
                                                borderStyle: 'solid',
                                                lineHeight: '25px'
                                            }}
                                        >
                                            {b}
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                    )
                })}
            </div>
        </div>
        
    )
}
